import B2bGroupsActions from 'Assets/js/Vuex/Store/actions/B2b/Groups';
import B2bContactsActions from 'Assets/js/Vuex/Store/actions/B2b/Contacts';
import B2bUserActions from 'Assets/js/Vuex/Store/actions/B2b/User';
import B2bCartOpsActions from 'Assets/js/Vuex/Store/actions/B2b/CartOps';
import B2bOrderActions from 'Assets/js/Vuex/Store/actions/B2b/Order';

export default {
  ...B2bGroupsActions,
  ...B2bContactsActions,
  ...B2bUserActions,
  ...B2bCartOpsActions,
  ...B2bOrderActions
};
